const { createSelector } = require('reselect')

const selectPostChatDataState = state => state.chat.postChatDataState
const selectPostChatData = () => createSelector(
  [selectPostChatDataState],
  cse => cse.data,
)
const selectPostChatDataLoading = () => createSelector(
  [selectPostChatDataState],
  cse => cse.loading,
)
const selectPostChatDataError = () => createSelector(
  [selectPostChatDataState],
  cse => cse.error,
)

const selectgetChatDataState = state => state.chat.getChatDataState
const getChatData = () => createSelector(
  [selectgetChatDataState],
  cse => cse.data,
)
const getChatDataLoading = () => createSelector(
  [selectgetChatDataState],
  cse => cse.loading,
)
const getChatDataError = () => createSelector(
  [selectgetChatDataState],
  cse => cse.error,
)

module.exports = {
  selectPostChatData,
  selectPostChatDataLoading,
  selectPostChatDataError,
  getChatData,
  getChatDataLoading,
  getChatDataError,
}
